"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changes_1 = require("../changes");
var utils_1 = require("../utils");
/**
 * User pressed Tab in an editor.
 * Tab       -> Increase item depth if inside a list item
 * Shift+Tab -> Decrease item depth if inside a list item
 */
function onTab(event, editor, opts, next) {
    var value = editor.value;
    var isCollapsed = value.selection.isCollapsed;
    if (!isCollapsed || !utils_1.getCurrentItem(opts)(value)) {
        return next();
    }
    // Shift+tab reduce depth
    if (event.shiftKey) {
        event.preventDefault();
        return changes_1.decreaseItemDepth(opts, editor);
    }
    // Tab increases depth
    event.preventDefault();
    return changes_1.increaseItemDepth(opts, editor);
}
exports.default = onTab;
//# sourceMappingURL=onTab.js.map